import BasePostGridSlider from "../../vendor/plug-and-play-design/pegasus-one-post-grid-slider/src/script";
import Flickity from "flickity";

class PostGridSlider extends BasePostGridSlider{
    constructor(autoplay, infinite) {
        super();
    }

    initSlider() {
        if(this.slider !== null){
            this.slider.destroy();
        }

        this.sliderContainer = this.$refs.slider;
        this.slides = this.sliderContainer.querySelectorAll(".slide");

        let options = {
            cellAlign: "left",
            contain: true,
            wrapAround: this.infinite,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            on: {
                settle: () => {
                    this.updateTabIndexes(this.slides);
                },
                change: () => {
                    this.selectedIndex = this.slider.selectedIndex;
                },
                dragStart: () => {
                    this.handleDragStartClassChanges();
                },
                dragEnd: () => {
                    this.handleDragEndClassChanges();
                },
            },
        };

        if (this.autoplay && this.autoplay > 0) {
            options.autoPlay = this.autoplay * 1000;
        }

        this.slider = new Flickity(this.sliderContainer, options);

        this.slider.on("scroll", (e) => {
            this.updateProgressBar();
        });

    }

    // Add 'pointer-events-none' when drag starts
    handleDragStartClassChanges() {
        const links = this.sliderContainer.querySelectorAll('.slider-team-member-link');
        links.forEach(link => {
            link.classList.add('pointer-events-none');
        });
    }

    // Remove 'pointer-events-none' when drag ends
    handleDragEndClassChanges() {
        const links = this.sliderContainer.querySelectorAll('.slider-team-member-link');
        links.forEach(link => {
            link.classList.remove('pointer-events-none');
        });
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGridSlider", (autoplay, infinite) => new PostGridSlider(autoplay, infinite));
});
